import { useCurrentUser, useUserPreferences } from '@witmetrics/data-store';
import Logo from '@/components/Logo';
import ProfilePicture from '@/components/ProfilePicture';
import TextLink from '@/components/TextLink';
import { classes } from './utils';

export type WelcomeMessageProps = {
  message: string;
  onLogout: () => void;
};

export default function WelcomeMessage({
  message,
  onLogout,
}: WelcomeMessageProps) {
  const currentUser = useCurrentUser();
  const userPreferences = useUserPreferences(currentUser?.id);

  if (!currentUser) return null;

  return (
    <>
      <div className={classes.logoRow}>
        <Logo />
      </div>
      <div className={classes.middle}>
        <div className={classes.avatarWrap}>
          <ProfilePicture
            className={classes.avatar}
            size={118}
            user={{ ...currentUser, userPreferences }}
          />
        </div>
        <h1 className={classes.welcome}>
          Welcome Back, {currentUser.firstname}!
        </h1>
        <p className={classes.message}>{message}</p>
      </div>
      <div className={classes.logoutRow}>
        <TextLink onClick={onLogout}>Logout</TextLink>
      </div>
    </>
  );
}
